import React, { useEffect } from 'react'
import { result } from 'libraries/lodash'
import { useDispatch } from 'react-redux'
import { setTiledMenuIsLoaded } from 'redux/actions'
import SectionHeaderContainer from 'redux/containers/pages/precedentscontent/details/SectionHeaderContainer'
import SectionsContainer from 'redux/containers/pages/precedentscontent/details/SectionsContainer'
import ResponseConsumer from 'components/shared/ResponseConsumer'
import Forbidden from 'components/shared/Forbidden'
import Error from 'components/shared/Error'
import usePrecedentSectionDetails from 'hooks/usePrecedentSectionDetails'

const SectionDetails = (props) => {
  const { baseState } = usePrecedentSectionDetails(props)
  const { isLimitedAccess, title } = props
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setTiledMenuIsLoaded(true))
  }, [])

  return (
    <ResponseConsumer
      response={baseState.response}
      notfoundComponent={() => isLimitedAccess ? <Forbidden /> : <Error {...{ title }} />}
      content={() => (
        <SectionDetailsComponent props={props} state={baseState} />
      )}
    />
  )
}

export default SectionDetails

const SectionDetailsComponent = ({ props, state }) => {
  const sectionTitle = result(state.response, ['nodes', props.sectionId, 'title'])

  return (
    <div>
      <div className='bg-ghost-grey'>
        <div className='layout-width-constraint'>
          <div className='bg-white mb12'>
            <SectionHeaderContainer
              {...{ ...props, sectionTitle }}
              expandedSection={state.expandedSection}
            />
            <SectionsContainer {...{ sectionTitle, ...props, ...state }} />
          </div>
        </div>
      </div>
    </div>
  )
}
